angular.module 'memberPortal', [
  'ui.router',
  'ui.bootstrap',
  'infinite-scroll',
  'shared',
  'restangular',
  'shared',
  'filters',
  'tandibar/ng-rollbar',
  'ngMask',
  'react'
]
  .run (Restangular, restangularInterceptors, $rootScope) ->
    Restangular
      .addRequestInterceptor restangularInterceptors.RequestInterceptor
      .addResponseInterceptor restangularInterceptors.ResponseInterceptor

    $rootScope.$on '$stateChangeError', ->
      console.error arguments[5]

  .config (
    $locationProvider,
    $stateProvider,
    $httpProvider,
    RestangularProvider,
    RollbarProvider
  ) ->
    meta = angular.element(document.querySelectorAll('meta[name=csrf-token]'))
    $httpProvider.interceptors.push('memberPortalHttp401Interceptor')
    $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-Token'
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    $locationProvider.html5Mode(true)
    RollbarProvider.init window._rollbarConfig
    RestangularProvider.setBaseUrl("/websites/#{window.DATA.domain}/members")
    $stateProvider
      .state 'memberPortal',
        url: '/websites/:domain/members',
        abstract: true,
        template: '<ui-view>'

      .state 'memberPortal.loginByEmail',
        url: '/login'
        controller: 'MemberLoginCtrl'
        template: require('templates/member_portal/login/login_by_email.html.slim')

      .state 'memberPortal.loginByHash',
        url: '/logins/:hash'
        controller: 'MemberLoginCtrl'
        template: require('templates/member_portal/login/login_by_hash.html.slim')

      .state 'memberPortal.forgotPin',
        url: '/pins/new?m'
        controller: 'MemberLoginCtrl'
        template: require('templates/member_portal/login/forgot_pin.html.slim')

      .state 'memberPortal.bookings',
        url: '/bookings?m'
        controller: 'BookingsCtrl'
        template: require('templates/member_portal/bookings/list.html.slim')
        data:
          title: 'Bookings'
        resolve:
          Bookings: (Restangular) ->
            Restangular.all('bookings')

      .state 'memberPortal.pastBookings',
        url: '/bookings/history?m'
        controller: 'BookingsCtrl'
        template: require('templates/member_portal/bookings/list.html.slim')
        data:
          title: 'Past Bookings'
        resolve:
          Bookings: (Restangular) ->
            Restangular.all('bookings').all('history')

      .state 'memberPortal.events',
        url: '/events?m&origin'
        controller: 'EventsCtrl'
        template: require('templates/member_portal/events/list.html.slim')
        data:
          title: 'Events'
        resolve:
          locations: (Restangular) ->
            Restangular.all('locations').getList(count: 100)
          instructors: (Restangular, DataService) ->
            if DataService.show_instructor_filter
              Restangular.all('instructors').getList(count: 100)
            else
              []
          styles: (Restangular,  DataService) ->
            if DataService.show_style_filter && DataService.martial_arts_gym
              Restangular.all('styles').getList(count: 100)
            else
              []
          eventTypes: (Restangular, DataService) ->
            if DataService.show_event_type_filter
              Restangular.all('event_types').getList(count: 100)
            else
              []
      .state 'memberPortal.showEvent',
        url: '/events/:id?m&origin'
        controller: 'ShowEventCtrl'
        template: require('templates/member_portal/events/show.html.slim')
        data:
          title: 'Event'
        resolve:
          event: ($stateParams, $http, DataService) ->
            url = "/websites/#{DataService.domain}/members/events/#{$stateParams.id}"
            $http.get(url).then (response) ->
              response.data

      .state 'memberPortal.styles',
        url: '/member_styles?m'
        controller: 'StylesCtrl'
        template: require('templates/member_portal/styles/list.html.slim')
        data:
          title: 'My MA Styles'
        resolve:
          styles: (Restangular) ->
            Restangular.all('member_styles').getList()

      .state 'memberPortal.profile',
        url: '/members/:id?m'
        controller: 'MemberProfileCtrl'
        template: require('templates/member_portal/profile/show.html.slim')
        data:
          title: 'Your Profile'

      .state 'memberPortal.card',
        url: '/members/:id/card?m'
        controller: 'MemberProfileCtrl'
        template: require('templates/member_portal/profile/card.html.slim')
        data:
          title: 'Membership ID Card'

      .state 'memberPortal.membership',
        url: '/memberships/:id?m'
        controller: 'MembershipCtrl'
        template: require('templates/member_portal/memberships/show.html.slim')
        data:
          title: 'Active Memberships'
        resolve:
          membership: ($stateParams, DataService) ->
            memberships = DataService.member_details.memberships
            _.find memberships, (membership) ->
              membership.id is parseInt($stateParams.id, 10)

      .state 'memberPortal.membershipPlans',
        url: '/membership_plans?m'
        controller: 'MembershipPlansCtrl'
        template: require('templates/member_portal/membership_plans/list.html.slim')
        data:
          title: 'Memberships'
        resolve:
          membershipPlans: (Restangular) ->
            Restangular.all('membership_plans').getList(count: 100)

      .state 'memberPortal.membershipPlan',
        url: '/membership_plans/:id?m'
        controller: 'MembershipPlanCtrl'
        template: require('templates/member_portal/membership_plans/show.html.slim')
        data:
          title: 'Purchase Membership'
        resolve:
          membershipPlans: (Restangular) ->
            Restangular.all('membership_plans').getList(count: 100)

          membershipPlan: (membershipPlans, $stateParams) ->
            _.find membershipPlans, (plan) ->
              plan.id is parseInt($stateParams.id, 10)

          membership: (membershipPlan, DataService) ->
            memberships = DataService.member_details.memberships
            _.find memberships, (membership) ->
              membership.membership_plan_id is membershipPlan.id
